// import React, { useEffect, useState } from 'react'
// import axios from 'axios';
// import Banner from './Banner'
// import './Home.css'
// import NewReleaseSection from './NewReleaseSection';
// import Banner2 from './Banner2';
// import Banner3 from './Banner3';

// const base_url = process.env.REACT_APP_BACKEND_URL;
// console.log(base_url);
// const API_URLS = {
//   newReleases: `${base_url}/collections/men-featured`,
//   bestSellers: `${base_url}/collections/men-new-arrivals`,
//   discounts: `${base_url}/collections/men-essentials`,
// };

// const useProducts = (url) => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     setLoading(true);
//     setError(null);
//     axios.get(url)
//       .then(res => {
//         console.log(res.data.products);
//         setProducts(res.data.products || [])
//       })
//       .catch(err => setError(err.message || 'Failed to fetch.'))
//       .finally(() => setLoading(false));
//   }, [url]);

//   return { products, loading, error };
// };

// const formatProducts = (products) => {
//   return products.map(prod => ({
//     id: prod.product_id,
//     title: prod.name,
//     color: prod.color,
//     price: prod.base_price,
//     originalPrice: prod.base_price,
//       discount: null,
//     frontImage: prod.image_url,
//     backImage: prod.extra_images ? prod.extra_images[0] : prod.image_url,
//     slug: prod.slug,
//     variants: prod.variants
//   }));
// };

// const Home = () => {
//   const section1 = useProducts(API_URLS.newReleases);
//   const section2 = useProducts(API_URLS.bestSellers);
//   const section3 = useProducts(API_URLS.discounts);

//   return (
//     <div className='homepage'>
//       <Banner shopButton={true} />
//       {section1.loading ? (
//         <div>Loading...</div>
//       ) : section1.error ? (
//         <div>Error: {section1.error}</div>
//       ) : (
//         <NewReleaseSection products={formatProducts(section1.products)} collectionTitle={"FEATURED PRODUCTS"} />
//       )}

//       <Banner2 shopButton={true} />
//       {section2.loading ? (
//         <div>Loading...</div>
//       ) : section2.error ? (
//         <div>Error: {section2.error}</div>
//       ) : (
//         <NewReleaseSection products={formatProducts(section2.products)} collectionTitle={"NEW RELEASES"} />
//       )}

//       <Banner3 shopButton={true} />
//       {section3.loading ? (
//         <div>Loading...</div>
//       ) : section3.error ? (
//         <div>Error: {section3.error}</div>
//       ) : (
//         <NewReleaseSection products={formatProducts(section3.products)} collectionTitle={"NEW OFFERS"} />
//       )}
//     </div>
//   )
// }

// export default Home

import React, { useEffect, useState } from "react";
import axios from "axios";
import Banner from "./Banner";
import "./Home.css";
import "../../responsive.css";
import NewReleaseSection from "./NewReleaseSection";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../Redux Store/Slice";

const base_url = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const [homepageData, setHomepageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  let dispatch = useDispatch();

  // ✅ Format products before passing to ProductCard components
  const formatProducts = (products) => {
    if (!products) return [];
    return products.map((prod) => ({
      id: prod.product_id,
      title: prod.name,
      color: prod.color,
      price: prod.base_price,
      originalPrice: prod.base_price,
      discount: null,
      frontImage: prod.image_url,
      backImage: prod.extra_images ? prod.extra_images[0] : prod.image_url,
      slug: prod.slug,
      variants: prod.variants || [],
    }));
  };

  useEffect(() => {
    const fetchHomepageData = async () => {
      try {
        const res = await axios.get(`${base_url}/homepage`);
        const data = res.data;

        // 🧠 Format products inside each section before saving state
        if (data.sections) {
          data.sections = data.sections.map((section) => ({
            ...section,
            products: formatProducts(section.products),
          }));
        }

        setHomepageData(data);
      } catch (err) {
        setError("Failed to load homepage content.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchHomepageData();
  }, []);

  useEffect(() => {
    if (loading) {
      dispatch(startLoading());
    } else {
      setTimeout(() => {
        dispatch(stopLoading());
      }, 1500)
    }
  }, [loading]);

  if (loading) return <p>Loading,,,</p>;
  if (error) return <div>{error}</div>;
  if (!homepageData) return <div>No homepage data found.</div>;

  const { banners, sections } = homepageData;

  return (
    <div className="homepage">
      {banners.map((banner, index) => (
        <React.Fragment key={banner.id}>
          <Banner
            image={banner.image_url}
            title={banner.title}
            description={banner.description}
            buttons={banner.buttons}
            isReversed={index % 2 !== 0}
          />
          {sections[index] && (
            <NewReleaseSection
              key={sections[index].id}
              products={sections[index].products || []}
              collectionTitle={sections[index].title}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Home;
